import Component from 'gia/Component';
import gsap from 'gsap';
import Splide from '@splidejs/splide';
// import { Draggable } from '../vendor/gsap-bonus-umd/Draggable';
// import { InertiaPlugin } from '../vendor/gsap-bonus-umd/InertiaPlugin';
// gsap.registerPlugin(Draggable,InertiaPlugin);

export default class Module extends Component
{
  mount() {
    this.DOM = {}
    this.DOM.view = this.element
    this.DOM.slideshow = this.DOM.view.querySelector('.jsSlideshow')

    // Draggable.create(this.DOM.view.querySelector('ul'), {
    //     type:"scrollLeft",
    //     bounds: {minX: 10, maxX: 2300, minY: 50, maxY: 500},
    //     inertia: true,
    //     onClick: function() {
    //         console.log("clicked");
    //     },
    //     onDragEnd: function() {
    //         console.log("drag ended");
    //     }
    // });
    this.makeSlideshow()
  }

  makeSlideshow()
  {
    this.slideshow = new Splide(this.DOM.slideshow , {
      arrows: false,
      autoWidth:true,
      gap:40,
      interval: 7000,
      padding:{ left:120, right:120 },
      pauseOnFocus:false,
      pauseOnHover:false,
      pagination:true,
      rewind:true,
      rewindByDrag:true,
      speed: 700,
      type: 'slide',
      breakpoints: {
        640: {
          arrows:false,
          gap: 24,
          padding:{ left:32, right:32 }
        },
        1680:{
          padding:{ left:70, right:70 }
        }
      },
    }).mount();
  }

  unmount()
  {

  }
}
